import { ObjectWithClassrooms } from '@teetsh/app/src/types/event';

export default function removeSeanceClassroomFromSeances(
  seances: ObjectWithClassrooms[],
  seanceId,
  classroomId,
) {
  return seances.reduce<ObjectWithClassrooms[]>((acc, num) => {
    if (num.id === seanceId) {
      const filteredClassroomsIds = num.classroomIds.filter(
        cId => cId !== classroomId,
      );
      if (filteredClassroomsIds.length === 0) {
        return acc;
      }
      return [
        ...acc,
        {
          ...num,
          classroomIds: filteredClassroomsIds,
        },
      ];
    }
    return [...acc, num];
  }, [] as ObjectWithClassrooms[]);
}
